import React, { useState, Fragment } from 'react'
import { NavLink } from "react-router-dom";
import classNames from "classnames/bind"

import styles from "./mobile-header.module.scss"

const cx = classNames.bind(styles)

export const MobileHeader = ({navigationItems, displayContactModal}) => {
    const [displayNav, setDisplayNav] = useState(false)

    const closeButton = () => {
        setDisplayNav(false)
    }

    const hamburgerButton = () => {
        setDisplayNav( !displayNav )
    }

    return (
        <Fragment>
            <div
                onClick={hamburgerButton}
                className={cx('hamburger-menu-wrapper')}
                aria-label="menu button"
                role="button"
                title="Tab/Click to open/close the menu"
            >
                    <span className={cx('hamburger-line')}></span>
                    <span className={cx('hamburger-line')}></span>
                    <span className={cx('hamburger-line')}></span>
            </div>

            {
                displayNav &&
                    <div className={cx(['mobile-navigation', "animate__animated", "animate__slideInLeft", "animate__faster"])}>
                        <div className={cx('close-button-wrapper')}>
                            <button onClick={ () => closeButton()} className={cx('close-button')} title="Click/Tap to close the menu">X</button>
                        </div>

                        <nav>
                            <ul>
                                {navigationItems.map( (nav, index) => {
                                    return (
                                        <li key={index} onClick={() => closeButton()}>
                                            <NavLink to={nav.link} activeClassName={cx("selected")} exact={nav.exact}>
                                                {nav.text}
                                                {nav.subNav && <span className={cx("arrow-down")}></span>}
                                            </NavLink>
                                        </li>
                                    )
                                })}
                                {/*<li onClick={() => displayContactModal()}>*/}
                                {/*    <a href="#">Contact</a>*/}
                                {/*</li>*/}
                            </ul>
                        </nav>
                    </div>
            }
        </Fragment>

    )
}